<div
    class="coverage-disabled"
    [class.coverage-disabled--bordered]="group.layout === coverageGroupLayoutEnum.Bordered"
    [class.coverage-disabled--bordered-disabled]="!input.acceptance || disabled"
    [class.coverage-disabled--border-bottom]="group.hasBorder"
    [insTooltip]="!input.acceptance || disabled ? 'Deze dekking is niet mogelijk in uw situatie' : null"
    placement="top"
>
    <label for="{{ input.id }}" class="coverage-disabled__label">
        <div class="coverage-disabled__input">
            <input
                type="checkbox"
                [(ngModel)]="value.enabled"
                [disabled]="disabled"
                id="{{ input.id }}"
                (change)="propagateChange()"
            />
            <label for="{{ input.id }}"></label>
        </div>
        <div class="coverage-disabled__name">
            {{ input?.data?.title }}
            <span *ngIf="input?.featured" class="coverage-disabled__feature-label">Meest gekozen</span>
        </div>
        <div class="coverage-disabled__info" *ngIf="input?.data?.body || input?.data?.tabs">
            <span
                (click)="
                    input?.data?.id === coverageIdEnum.CarDamageInsuranceOccupants
                        ? infoModalAdditionalCoverage($event, input)
                        : infoModalCoverageControl($event)
                "
            >
                <wuc-icon-ui class="coverage-disabled__info--icon" icon="information" size="xs"></wuc-icon-ui>
                <span class="coverage-disabled__info--link link-secondary">meer info</span>
            </span>
        </div>
        <div class="coverage-disabled__price">
            {{ input?.price | number : "1.2-2" }}
        </div>
    </label>
</div>
